import React, { Component } from 'react';
import FlipMove from 'react-flip-move';
import { Waypoint } from 'react-waypoint';
import { Scrollbars } from 'react-custom-scrollbars';
import ActivityFeedKicked from './ActivityFeedKicked';
import ActivityFeedNews from "./ActivityFeedNews";
import ActivityFeedDemotion from "./ActivityFeedDemotion";
import ActivityFeedPromotion from "./ActivityFeedPromotion";
import ActivityFeedNewChapter from "./ActivityFeedNewChapter";
import ActivityFeedQuote from "./ActivityFeedQuote";
import ActivityFeedJoinChapter from "./ActivityFeedJoinChapter";
import ActivityFeedPost from "./ActivityFeedPost";
import ActivityFeedAward from "./ActivityFeedAward";
import ActivityFeedScreenshot from "./ActivityFeedScreenshot";
import ActivityFeedDKPItem from "./ActivityFeedDKPItem";
import ActivityFeedDKPEvent from "./ActivityFeedDKPEvent";
import ActivityFeedForm from './ActivityFeedForm';
import { toArray } from '../common/util';

class ActivityFeed extends Component {
    constructor(props) {
        super(props);

        this.state = {
            width: 0,
            height: 0,
        };

        this.handleUpdate= this.handleUpdate.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentSwitch(item) {
        if (!item.isDeleted) {
            switch (item.type) {
                case "kicked":
                    return <ActivityFeedKicked users={this.props.users} ranks={this.props.ranks} item={item}/>;
                case "news":
                    return <ActivityFeedNews users={this.props.users} ranks={this.props.ranks} item={item}/>;
                case "demotion":
                    return <ActivityFeedDemotion users={this.props.users} ranks={this.props.ranks} item={item}/>;
                case "promotion":
                    return <ActivityFeedPromotion users={this.props.users} ranks={this.props.ranks} item={item}/>;
                case "new_chapter":
                    return <ActivityFeedNewChapter users={this.props.users} ranks={this.props.ranks}
                                                   chapters={this.props.chapters} item={item}/>;
                case "quote":
                    return <ActivityFeedQuote users={this.props.users} ranks={this.props.ranks} item={item}/>;
                case "screenshot":
                    return <ActivityFeedScreenshot users={this.props.users} ranks={this.props.ranks} item={item}/>;
                case "join_chapter":
                    return <ActivityFeedJoinChapter users={this.props.users} ranks={this.props.ranks}
                                                    chapters={this.props.chapters} item={item}/>;
                case "feed_post":
                    return <ActivityFeedPost users={this.props.users} ranks={this.props.ranks} item={item}/>;
                case "award":
                    return <ActivityFeedAward users={this.props.users} ranks={this.props.ranks} item={item}/>;
                case "dkp_item":
                    return <ActivityFeedDKPItem users={this.props.users} ranks={this.props.ranks} item={item}/>;
                case "dkp_event":
                    return <ActivityFeedDKPEvent users={this.props.users} ranks={this.props.ranks} item={item}/>;
                default:
                    return null
            }
        }
    }

    handleUpdate() {
        if (!this.props.feed.pending && this.props.feed.more) {
            this.props.appendFeed(this.props.feed.limit, this.props.feed.offset);
        }
    }

    render() {
        const feedSorted = toArray(this.props.feed.data).sort((a, b) => (new Date(b.created).getTime() - new Date(a.created).getTime()));

        const feedComponents = feedSorted.map((item) => (
            <div key={`${item.id}-feed`}>{this.componentSwitch(item)}</div>
        ));

        return (
            <div className={"right" + (this.props.open ? ' show' : '')} id="rightPanel">
                <ActivityFeedForm onSubmit={this.props.onSubmit} isAuthenticated={this.props.isAuthenticated} />
                <Scrollbars
                    renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                    renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}
                    autoHide
                    style={{height:this.state.height-78}}
                >
                    <FlipMove
                        staggerDelayBy={50}
                        appearAnimation="fade"
                        enterAnimation="fade"
                        leaveAnimation="fade"
                        typename="ul"
                        className="activity-list"
                    >
                        {feedComponents}
                    </FlipMove>
                    <div>
                        <Waypoint
                            key="waypoint"
                            onEnter={this.handleUpdate}
                            bottomOffset='-20%'
                        />
                    </div>
                </Scrollbars>
            </div>
        );
    }
}

export default ActivityFeed;


// WEBPACK FOOTER //
// ./src/ActivityFeed/ActivityFeed.js